import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

// Registre o ArcElement para gráficos de pizza
ChartJS.register(ArcElement, Tooltip, Legend);

export default function GraficoPizza({ data, options }) {
  return <Pie data={data} options={options} />;
}